
import type { PropType } from 'vue'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { useRoles } from '../../composables/users/use-roles'
import { capitalizeSentence } from '../../filters/capitalize-sentence.filter'
import { EpbBadge } from '../shared/epb-badge'
import { EpbPill } from '../shared/epb-pill'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'RolePill',
  components: {
    EpbBadge,
    EpbPill,
    EpbText,
  },
  props: {
    role: {
      type: String,
      required: true,
    },
    instancesIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    size: {
      type: String as PropType<'small' | 'mini'>,
      default: 'small',
    },
  },
  setup(props) {
    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const baseClass = 'epb-role-pill'

    const messages = ctx.proxy.$epb.messages.userRoleManagement.instances

    const {
      data: { list: data },
      getColor,
    } = useRoles()

    const color = computed(() => getColor(props.role))

    const tooltip = computed(
      () => data.value?.results.find(role => role.name === props.role)?.description,
    )

    const instancesTooltip = computed(() =>
      ctx.proxy.$epb.utils.compileMessage(messages.tooltip as string, {
        instancesIds: props.instancesIds
          .map(instanceId => capitalizeSentence(instanceId))
          .join(', '),
      }),
    )

    return {
      baseClass,
      color,
      tooltip,
      instancesTooltip,
    }
  },
})
